import React, { Component, Fragment } from 'react';
import { Field } from 'react-final-form';
import moment from 'moment';

import Input from '../../formComponents/Input';
import Checkbox from '../../formComponents/Checkbox';
import Radio from '../../formComponents/Radio';
import Datepicker from '../../formComponents/Datepicker';

class OPDDefault extends Component {
    render() {
        return (
            <Fragment>
                <div className="container">
                    <div>
                        <p>Hereby, in compliance with the requirements of the Law of the Republic of Kazakhstan No. 94-V ZRK dated May 21, 2013 "On Personal Data and Its Protection", I, </p>
                        <div className="form">
                            <div className="item">
                                <Field name='lastName' component={Input} placeholder={this.props.t('fields.lastName')} />
                            </div>
                            <div className="item">
                                <Field name='firstName' component={Input} placeholder={this.props.t('fields.firstName')} />
                            </div>
                            <div className="item">
                                <Field name='middleName' component={Input} placeholder={this.props.t('fields.middleName')} />
                            </div>
                            <div className="item">
                                <Field name='birthdate' component={Datepicker} placeholder={this.props.t('fields.birthdate')} max={moment()} />
                            </div>
                            <div className="item">
                                <Field name='phone' component={Input} placeholder={this.props.t('fields.phone')} />
                            </div>
                            <div className="item">
                                <Field name='emailPersonal' disabled={true} component={Input} placeholder={this.props.t('fields.email')} />
                            </div>
                            <div className="item">
                                <Field name='address' component={Input} placeholder={this.props.t('fields.address')} />
                            </div>
                        </div>
                    </div>
                    <div>
                        <p>acting freely, of my own will and in my own interest, as well as confirming my legal capacity, </p>
                    </div>
                    <div className="item-form">
                        <Field
                            required={true}
                            name='SoglasieOPD'
                            component={Checkbox}
                            text={<span>I give my consent to ANCOR STAFF Central Asia LLP (registered address: 115 Zheltoksan St., Almalinsky District, Almaty), its separate divisions, and its group of legal entities<sup>1</sup> (hereinafter referred to as “the Operator”) to process my personal data for the following purposes:</span>}
                        />
                    </div>
                    <div>
                        <ul>
                            <li>assistance in employment or organization of another type of cooperation;</li>
                            <li>conducting a preliminary interview for the purpose of full-time or other forms of employment;</li>
                            <li>the Operator carrying out activities related both to labor market analysis and to human resources management, including placing the Applicant's personal data in the applicant pool.</li>
                        </ul>
                        <p>I also give my consent to:</p>
                        <ul>
                            <li>transferring of my personal data, including cross-border, to the Operator, the Operator’s Group of Entities1  and to third parties — the Operator's clients<sup>2</sup>  —for the above purposes;</li>
                            <li>the personal data being entrusted for procession to TeamService LLC (21 Entuziastov Shosse, Bldg. 2, Moscow, 111024 Russian Federation) and Experium LLC (2 Entuziastov boulevard, 13 floor, office 36, Moscow, 109544 Russian Federation) for the purpose of ensuring technical support of the Operator's information systems.</li>
                        </ul>
                        <p>Personal data categories:</p>
                        <ul>
                            <li>name, patronymic, surname;</li>
                            <li>gender;</li>
                            <li>photo;</li>
                            <li>contact phone number;</li>
                            <li>email address;</li>
                            <li>date of birth:</li>
                            <li>citizenship</li>
                            <li>city and area of residence;</li>
                            <li>address of personal web page on social networks;</li>
                            <li>readiness for relocation and business trips;</li>
                            <li>marital status;</li>
                            <li>information about education and specialty;</li>
                            <li>information about previous jobs;</li>
                            <li>computer proficiency level;</li>
                            <li>foreign language proficiency level;</li>
                            <li>information about the special professional skills;</li>
                            <li>salary expectations;</li>
                            <li>other personal data that I consider necessary to include in my CV;</li>
                            <li>recommendations from previous employers.</li>
                        </ul>
                    </div>
                    <div className="item-form">
                        <Field
                            required={true}
                            name='SoglasieMSG'
                            component={Radio}
                            text='I further give my consent to receive electronic messages carried out to inform me about emerging career opportunities, training materials and invitations to events regarding this sphere:' />
                    </div>
                    <div>
                        <p>
                        This consent to the personal data processing shall remain in effect until the withdrawal of the consent is received by the Operator. I have read and understood the procedure of the consent withdrawal<sup>3</sup>.
                        </p>
                    </div>
                    <small className='text-ref'>
                        <sup>1</sup>&nbsp;“The Group of Entities” is used in the meaning of the concept defined in Article 7 of the Law of the Republic of Kazakhstan "On Protection of Competition" No. 112-IV of 25.12.2008 <br/>
                        <sup>2</sup>&nbsp;The Applicant's data may be transferred only to the Clients of the Operator and of the Operator’s Group of Entities – who are potential employers for the Applicant.
                        <sup>3</sup>&nbsp;Withdrawal of consent to processing of the personal data shall contain the full name, date of birth, email address, mobile phone, personal signature of the Applicant
                        <br />
                        The extract from the Law of the Republic of Kazakhstan No. 94-V ZRK "On Personal Data and Its Protection" on the procedure of such a withdrawal: "the subject or his/her legal representative shall give (withdraw) the consent to collection, processing of the personal data in written form or in the form of an electronic document or in another form ensuring protecting actions undertaken do not contradict the laws of the Republic of Kazakhstan. The subject or his/her legal representative cannot withdraw the consent to collection, processing of the personal data in cases where this is contrary to the laws of the Republic of Kazakhstan or unfulfilled obligations remain."
                        <br />
                        A scanned copy of the withdrawal can be sent to <a href="mailto:privacy@ancor.kz">privacy@ancor.kz</a>. The paper original of the withdrawal can be submitted to any office of the ANCOR Group. The Operator shall be obliged to cease processing of and destroy the personal data after the receipt of the said withdrawal, except for those personal data the procession of which does not require consent of the personal data subject in accordance with the Law of the Republic of Kazakhstan No. 94-V ZRK of May 21, 2013 "On Personal Data and Its Protection" or other regulatory legal acts.
                    </small>
                </div>
            </Fragment>
        );
    }
}

export default OPDDefault;
